<template>
	<b-modal
		ref="modal"
		id="confirm-dialog"
		hide-header
		hide-footer
		centered
		body-class="modal__confirm"
		size="lg"
		@shown="focusInput"
	>
		<div class="modal__message">
			<h5>{{message}}</h5>
			<div class="form-group">
				<label :for="label">{{label}}</label>
				<input type="text" :id="label" v-model="inputData" class="form-control" ref="inputField">
			</div>
		</div>
		<div class="modal__controls">
			<button class="btn btn-primary" @click="emitValue">Ok</button>
		</div>
	</b-modal>
</template>

<script>
export default {
	name: "InputDialog",
	props: ["message","label"],
	data: function () {
		return {
			inputData: '',
		};
	},
	methods: {
		show: function (url) {
			this.inputData = url;
			this.$refs["modal"].show();
		},
		hide: function () {
			this.$refs["modal"].hide();
		},
		emitValue: function () {
			this.$emit('valueinserted', this.inputData);
			this.inputData = '';
		},
		focusInput: function () {
			this.$refs.inputField.focus();
		}
	},
};
</script>

<style>
.modal__controls {
	display: flex;
	align-items: center;
	justify-content: flex-end;
}
.modal__message {
	font-weight: bold;
	margin-bottom: 3rem;
}
</style>